// extracted by mini-css-extract-plugin
export default {"parent":"PaymentCardList_parent__7-iw0","parentDisabled":"PaymentCardList_parentDisabled__saHdt"};